export default [
  {id: 1, codigo: 'ABACATE', label: 'Abacate'},
  {id: 2, codigo: 'ACAI_PLANT', label: 'Açaí-plantado (frutos)'},
  {id: 3, codigo: 'ACEROLA', label: 'Acerola'},
  {id: 4, codigo: 'ALGODAO_ARBOREO', label: 'Algodão arbóreo (em caroço)'},
  {id: 5, codigo: 'AMEIXA', label: 'Ameixa'},
  {id: 6, codigo: 'AMOREIRA', label: 'Amoreira (folhas)'},
  {id: 7, codigo: 'AZEITONA', label: 'Azeitona'},
  {id: 8, codigo: 'BANANA', label: 'Banana'},
  {id: 9, codigo: 'BORRACHA_PLANT', label: 'Borracha-plantada (seringal de cultivo)'},
  {id: 10, codigo: 'CACAU', label: 'Cacau (em caroço)'},
  {id: 11, codigo: 'CAFE', label: 'Café (em caroço)'},
  {id: 12, codigo: 'CAJU', label: 'Caju (frutos)'},
  {id: 13, codigo: 'CANA_ACUCAR', label: 'Cana-de-açúcar'},
  {id: 14, codigo: 'CAQUI', label: 'Caqui'},
  {id: 15, codigo: 'COCO', label: 'Côco'},
  {id: 16, codigo: 'CRAVO', label: 'Cravo-da-Índia'},
  {id: 17, codigo: 'CUPUACU', label: 'Cupuaçu-plantado (frutos)'},
  {id: 18, codigo: 'DAMASCO', label: 'Damasco'},
  {id: 19, codigo: 'DENDE_PLANT', label: 'Dendê-plantado'},
  {id: 20, codigo: 'ERVA_MATE', label: 'Erva Mate-plantado (folhas)'},
  {id: 21, codigo: 'EUCALIPTO', label: 'Eucalipto (reflorestamento com essência exótica)'},
  {id: 22, codigo: 'FIGO', label: 'Figo'},
  {id: 23, codigo: 'FRUTA_CONDE', label: 'Fruta-do-conde (Ata ou Pinha)'},
  {id: 24, codigo: 'GOIABA', label: 'Goiaba'},
  {id: 25, codigo: 'GRAVIOLA', label: 'Graviola'},
  {id: 26, codigo: 'GUARANA_PLANT', label: 'Guaraná-plantado (sementes)'},
  {id: 27, codigo: 'JACA', label: 'Jaca'},
  {id: 28, codigo: 'KIWI', label: 'Kiwi'},
  {id: 29, codigo: 'LARANJA', label: 'Laranja'},
  {id: 30, codigo: 'LIMA', label: 'Lima'},
  {id: 31, codigo: 'LIMAO', label: 'Limão'},
  {id: 32, codigo: 'MACA', label: 'Maçã'},
  {id: 33, codigo: 'MAMAO', label: 'Mamão'},
  {id: 35, codigo: 'MANGA', label: 'Manga'},
  {id: 36, codigo: 'MARACUJA', label: 'Maracujá'},
  {id: 37, codigo: 'MARMELO', label: 'Marmelo'},
  {id: 38, codigo: 'NECTARINA', label: 'Nectarina'},
  {id: 39, codigo: 'NESPERA', label: 'Nêspera'},
  {id: 40, codigo: 'NOZ', label: 'Nóz'},
  {id: 41, codigo: 'OUTRAS_ESSENCIAS', label: 'Outras essências exóticas (reflorestamento)'},
  {id: 42, codigo: 'PALMITO_PLANT', label: 'Palmito-plantado'},
  {id: 43, codigo: 'PERA', label: 'Pera'},
  {id: 44, codigo: 'PESSEGO', label: 'Pêssego'},
  {id: 45, codigo: 'PIMENTA_REINO', label: 'Pimenta do Reino'},
  {id: 46, codigo: 'PINUS', label: 'Pinus (reflorestamento com essência exótica)'},
  {id: 47, codigo: 'TANGERINA', label: 'Tangerina (Bergamota, Mexerica ou Poncã)'},
  {id: 48, codigo: 'URUCUM_PLANT', label: 'Urucum-plantado (sementes)'},
  {id: 49, codigo: 'UVA', label: 'Uva'},
  {id: 50, codigo: 'OUTROS', label: 'Outros'}
]



// WEBPACK FOOTER //
// ./src/utils/tipoCulturasPermanentes.js